import {
  DiscoveredListing,
  DiscoveredListings,
} from "../../../services/instruments";
import { ListingDiscovery } from "./types";

export const toDiscoveryState = ({
  outcome,
  candidates,
}: DiscoveredListings): ListingDiscovery => {
  if (outcome === "MATCH" && candidates.length > 0) {
    return { status: "found", listing: candidates[0] };
  }
  if (outcome === "AMBIGUOUS" && candidates.length > 0) {
    return { status: "ambiguous", candidates };
  }
  return { status: "none" };
};

export const noListingMessage = (symbol: string, exchange: string) =>
  `No listing found for ${symbol} on ${exchange}. Check the symbol and exchange.`;

const listingVenue = (listing: DiscoveredListing) =>
  listing.exchangeDisplayName ?? listing.providerExchange;

const listingMeta = (listing: DiscoveredListing) =>
  [listingVenue(listing), listing.assetType].filter(Boolean).join(" · ");

export const listingDescription = (listing: DiscoveredListing) =>
  [listing.yahooSymbol, listingMeta(listing), listing.name]
    .filter(Boolean)
    .join(" — ");
